import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { WorkplaceProvider } from "../context/WorkplaceContext";
import DefaultLayout from "../layouts/DefaultLayout";
import Login from "../views/Login";
import EntryExit from "../views/EntryExit";
import DashBoard from "../views/DashBoard";
import Event from "../views/Event";
import FacilityMonitoring from "../views/FacilityMonitoring";
import IntegratedControl from "../views/IntegratedControl";
import Management from "../views/Management";
import BeaconsManagement from "../views/BeaconsManagement";
import RealtimeVideo from "../views/RealtimeVideo";
import RecordingVideo from "../views/RecordingVideo";
import DashBoardForGate from "../views/DashBoardForGate";
import DashBoardForLocation from "../views/DashBoardForLocation";
import DashBoardOnlyGas from "../views/DashBoardOnlyGas";

const AppRoutes = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("userid")
  );

  const handleLogout = () => {
    localStorage.removeItem("userid");
    localStorage.removeItem("username");
    localStorage.removeItem("usertype");
    localStorage.removeItem("workplaceid");

    setIsAuthenticated(false); // 인증 상태 업데이트
  };

  return (
    <WorkplaceProvider>
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              isAuthenticated ? (
                <Navigate to="/entryexit" />
              ) : (
                <Login setIsAuthenticated={setIsAuthenticated} />
              )
            }
          />

          {isAuthenticated ? (
            <>
              <Route
                path="/*"
                element={
                  <DefaultLayout handleLogout={handleLogout}>
                    <Routes>
                      <Route path="entryexit" element={<EntryExit />} />
                      <Route path="event" element={<Event />} />
                      <Route
                        path="facilitymonitoring"
                        element={<FacilityMonitoring />}
                      />
                      <Route
                        path="integratedcontrol"
                        element={<IntegratedControl />}
                      />
                      <Route path="management" element={<Management />} />
                      <Route path="realtimevideo" element={<RealtimeVideo />} />
                      <Route
                        path="recordingvideo"
                        element={<RecordingVideo />}
                      />
                      <Route
                        path="beacons/management"
                        element={<BeaconsManagement />}
                      />
                    </Routes>
                  </DefaultLayout>
                }
              />
              <Route path="dashboard" element={<DashBoard />} />
              <Route path="dashboard/gate" element={<DashBoardForGate />} />
              <Route path="dashboard/gas" element={<DashBoardOnlyGas />} />
              <Route
                path="dashboard/location"
                element={<DashBoardForLocation />}
              />
            </>
          ) : (
            <Route path="*" element={<Navigate to="/" />} />
          )}
        </Routes>
      </Router>
    </WorkplaceProvider>
  );
};

export default AppRoutes;
